import { memo } from 'react';

import CatalogBanner from '@LandingComponents/CatalogBanner';
import useMedias from '@Hooks/useMedias';

import type { FC, HTMLAttributes } from 'react';
import type { CatalogBannerData } from '@Pages/PageHranenie/typings';

interface CatalogBannerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  cnTitle?: string;
  bannerData: CatalogBannerData;
}

const CatalogBannerWrapper: FC<CatalogBannerProps> = (props) => {
  const { bannerData, cnTitle, className } = props;
  const { isMobile } = useMedias();

  const modifiedLeftBlock = Array.isArray(bannerData.leftBlock) ? [...bannerData.leftBlock] : [];
  const modifiedRightBlock = Array.isArray(bannerData.rightBlock) ? [...bannerData.rightBlock] : [];

  modifiedLeftBlock[0] = isMobile ? modifiedRightBlock[2] : modifiedLeftBlock[0];

  const modifiedBannerData = {
    ...bannerData,
    leftBlock: modifiedLeftBlock,
    rightBlock: modifiedRightBlock,
  };

  return (
    <CatalogBanner
      bannerData={modifiedBannerData}
      cnTitle={cnTitle}
      className={className}
    ></CatalogBanner>
  );
};

export default memo(CatalogBannerWrapper);
